import { cva } from '../tokens/variants';

export const skeletonVariants = cva('animate-pulse bg-[var(--tk-surface-border)]', {
  variants: {
    shape: {
      rect: 'rounded-tk-md',
      pill: 'rounded-tk-full',
      circle: 'rounded-full aspect-square',
      text: 'rounded-tk-xs',
    },
  },
  defaultVariants: { shape: 'rect' },
});
